import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Regexs } from '@utils/regex';
import { TaskCaseService } from 'src/app/modules/case/services/taskCase.service';
import { RastreoMovimientosBancarios } from '../../../../interfaces/ratreo-movimientos-bancarios';
import { CaseRecordService } from 'src/app/modules/case/services/case-record.service';
import { CasesService } from 'src/app/core/services/cases.service';

@Component({
  selector: 'app-rastreo-movimientos-bancarios',
  templateUrl: './rastreo-movimientos-bancarios.component.html',
  styleUrls: ['./rastreo-movimientos-bancarios.component.scss'],
})
export class RastreoMovimientosBancariosComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = [
    'cuenta_origen',
    'cuenta_destino',
    'monto',
    'fecha',
    'opciones',
  ];
  dataSource = new MatTableDataSource<any>();
  tableValues: RastreoMovimientosBancarios[] = [];

  formTable: FormGroup;
  formFile: FormGroup;
  submit = false;
  submitFile = false;
  file: File | null;

  @Input() data: { task: any };

  constructor(
    private fb: FormBuilder,
    public taskCaseService: TaskCaseService,
    private readonly caseRecordService: CaseRecordService,
    private caseService: CasesService
  ) {}
  icase;
  get status() {
    return this.icase?.status == 'archived';
  }
  ngOnInit(): void {
    let caseId: any;
    if (typeof this.data.task.case == 'object') {
      caseId = this.data.task.case._id;
    } else if (typeof this.data.task.case == 'string') {
      caseId = this.data.task.case;
    }
    this.caseService.getCase(caseId).subscribe((res) => {
      this.icase = res;
    });
    const { task } = this.data;
    const values = task.data ? task.data : [];
    this.tableValues = values;

    this.formTable = this.fb.group({
      cuenta_origen: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAccountNumber)],
      ],
      cuenta_destino: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAccountNumber)],
      ],
      monto: [
        '',
        [Validators.required, Validators.pattern(Regexs.regexAmount)],
      ],
      fecha: ['', [Validators.required]],
    });
    this.formFile = this.fb.group({
      file: [null],
    });

    this.initializeTable();
  }

  verificateInput(value: string) {
    return (
      this.formTable.get(value)?.invalid &&
      (this.formTable.get(value)?.dirty || this.formTable.get(value)?.touched)
    );
  }

  addData() {
    if (this.formTable.invalid || this.submit) return;
    this.submit = true;
    this.tableValues.unshift(this.formTable.value);
    this.taskCaseService
      .updateTaskCase(this.data.task._id, {
        data: this.tableValues,
        // ignore: true,
      })
      .subscribe(
        (caseUpdated) => {
          this.formTable.reset();
          this.initializeTable();
          this.taskCaseService.taskUpdated.next({ task: caseUpdated });
          this.caseRecordService.updatedRecord.next(true);
        },
        (erorr) => {
          this.submit = false;
        }
      );
  }

  removerCuenta(index: number) {
    this.tableValues.splice(index, 1);
    this.taskCaseService
      .updateTaskCase(this.data.task._id, { data: this.tableValues })
      .subscribe((caseUpdated) => {
        this.initializeTable();
        this.taskCaseService.taskUpdated.next({ task: caseUpdated });
        this.caseRecordService.updatedRecord.next(true);
      });
  }

  initializeTable() {
    this.dataSource = new MatTableDataSource<RastreoMovimientosBancarios>(
      this.tableValues
    );
    this.dataSource.paginator = this.paginator;
    this.submit = false;
    this.submitFile = false;
  }
}
